var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M38.345,423.721h132.322V88.273H38.345C17.167,88.273,0,105.44,0,126.618v258.759 C0,406.554,17.167,423.721,38.345,423.721z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.67,
    y: 88.277,
    style: {
      fill: "#FF4B55"
    },
    width: 170.67,
    height: 335.45
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M473.655,423.721c21.177,0,38.345-17.167,38.345-38.345V126.618 c0-21.177-17.167-38.345-38.345-38.345H341.334v335.448H473.655z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 235.52,
    y: 247.707,
    style: {
      fill: "#F5F5F5"
    },
    width: 7.679,
    height: 2.56
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "279.038,273.303 232.962,273.303 235.522,268.185 276.478,268.185  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "279.038,232.348 232.962,232.348 235.522,237.468 276.478,237.468  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "268.799,234.908 243.201,234.908 248.321,229.788 263.68,229.788  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.52,
    y: 260.507,
    style: {
      fill: "#F5F5F5"
    },
    width: 7.679,
    height: 5.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.52,
    y: 252.827,
    style: {
      fill: "#F5F5F5"
    },
    width: 7.679,
    height: 5.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.52,
    y: 240.027,
    style: {
      fill: "#F5F5F5"
    },
    width: 7.679,
    height: 5.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: 260.507,
    style: {
      fill: "#F5F5F5"
    },
    width: 7.679,
    height: 5.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: 252.827,
    style: {
      fill: "#F5F5F5"
    },
    width: 7.679,
    height: 5.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: 240.027,
    style: {
      fill: "#F5F5F5"
    },
    width: 7.679,
    height: 5.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: 247.707,
    style: {
      fill: "#F5F5F5"
    },
    width: 7.679,
    height: 2.56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.08,
    y: 219.547,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.12,
    height: 10.239
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M243.201,216.989h-5.12v-2.56c0-1.414,1.146-2.56,2.56-2.56l0,0c1.414,0,2.56,1.146,2.56,2.56 V216.989L243.201,216.989z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: 219.547,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.12,
    height: 10.239
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M273.919,216.989h-5.12v-2.56c0-1.414,1.146-2.56,2.56-2.56l0,0c1.414,0,2.56,1.146,2.56,2.56 V216.989L273.919,216.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M256,240.027L256,240.027c-5.655,0-10.239,4.584-10.239,10.239v15.359h20.478v-15.359 C266.239,244.612,261.655,240.027,256,240.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M239.053,256.153l-13.937-16.259c0.09-0.263,0.167-0.533,0.167-0.826c0-1.414-1.146-2.56-2.56-2.56 s-2.56,1.146-2.56,2.56s1.146,2.56,2.56,2.56c0.154,0,0.288-0.062,0.434-0.087l1.442,1.683l-6.996,16.323l7.679,7.679l6.631-15.47 l5.197,6.063L239.053,256.153z M226.601,261.501l-6.127-6.127l2.764-6.451l6.127,6.127L226.601,261.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M274.954,257.818l5.197-6.063l6.631,15.47l7.679-7.679l-6.996-16.323l1.442-1.683 c0.147,0.025,0.28,0.087,0.434,0.087c1.414,0,2.56-1.146,2.56-2.56s-1.146-2.56-2.56-2.56s-2.56,1.146-2.56,2.56 c0,0.294,0.076,0.564,0.167,0.826l-13.937,16.259L274.954,257.818z M282.699,255.05l6.127-6.127l2.764,6.451l-6.127,6.127 L282.699,255.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M258.898,214.876c-0.804-0.237-1.522-0.676-1.976-1.38c-0.303-0.471-0.612-1.006-0.921-1.625 c-0.309,0.619-0.618,1.154-0.921,1.625c-0.455,0.705-1.172,1.144-1.976,1.38c-4.241,1.249-7.342,5.148-7.342,9.793 c0,0.889,0.149,1.737,0.362,2.56h19.754c0.213-0.823,0.362-1.671,0.362-2.56C266.239,220.023,263.138,216.125,258.898,214.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M197.34,252.526c-0.13-1.591-0.214-3.194-0.214-4.819c0-3.288,0.298-6.522,0.826-9.695 c0.738,0.511,1.511,1.073,2.314,1.704c-0.375,2.625-0.582,5.291-0.582,7.991c0,1.892,0.097,3.763,0.28,5.608l5.411,1.625 c-0.338-2.37-0.572-4.772-0.572-7.233c0-1.224,0.073-2.433,0.17-3.638c2.826,3.134,5.056,6.92,5.056,11.104 c0,0.107,8.213-12.159-6.719-25.704l-0.107,5.759l-8.6-0.09c-0.775-0.008-1.457,0.542-1.592,1.305 c-0.654,3.679-1.006,7.441-1.006,11.264c0,1.087,0.029,2.167,0.082,3.241L197.34,252.526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M220.053,201.096c1.119-0.863,1.325-2.47,0.461-3.59c-0.866-1.12-2.472-1.322-3.591-0.46 c-11.585,8.947-19.535,21.239-22.978,35.008l5.276,0.068C202.541,219.936,209.726,209.072,220.053,201.096z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M216.623,207.481c-5.567,5.452-9.781,11.869-12.648,18.839c1.583,1.301,2.88,2.615,3.957,3.922 c2.58-7.107,6.689-13.632,12.274-19.101c1.01-0.99,1.027-2.61,0.038-3.619C219.252,206.508,217.633,206.491,216.623,207.481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M207.727,281.267c-3.796-5.447-6.697-11.555-8.498-18.116l2.976,1.094 c1.859,5.987,4.68,11.555,8.292,16.516l5.65-1.034c-3.19-3.965-5.812-8.404-7.727-13.198l3.34,1.227 c1.906,4.185,4.346,8.033,7.255,11.447l5.879-1.077c-2.312-2.36-4.334-5.017-6.076-7.883l-3.406-6.812 c-1.052-2.104-2.925-3.68-5.178-4.355l-8.058-2.422l-1.863-0.559l-2.682-0.807l-5.335-1.603l-2.848-0.856l1.762,5.288 c0.387,1.161,1.17,2.13,2.188,2.766c1.629,7.735,4.65,14.962,8.8,21.4L207.727,281.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M308.794,235.228l-0.107-5.759c-14.932,13.545-6.719,25.811-6.719,25.704 c0-4.184,2.23-7.97,5.056-11.104c0.097,1.205,0.17,2.415,0.17,3.638c0,2.462-0.234,4.864-0.572,7.233l5.411-1.625 c0.183-1.845,0.28-3.715,0.28-5.608c0-2.701-0.206-5.367-0.582-7.991c0.803-0.63,1.577-1.193,2.314-1.704 c0.529,3.172,0.826,6.408,0.826,9.695c0,1.624-0.084,3.228-0.214,4.819l5.251-1.578c0.054-1.074,0.082-2.154,0.082-3.241 c0-3.823-0.353-7.585-1.006-11.264c-0.136-0.764-0.818-1.313-1.592-1.305L308.794,235.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M312.78,232.123l5.276-0.068c-3.444-13.769-11.393-26.061-22.978-35.008 c-1.119-0.863-2.724-0.66-3.591,0.46c-0.864,1.12-0.658,2.728,0.461,3.59C302.274,209.072,309.459,219.936,312.78,232.123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M308.025,226.32c-2.868-6.97-7.081-13.387-12.648-18.839c-1.01-0.99-2.628-0.972-3.619,0.04 c-0.99,1.01-0.972,2.63,0.038,3.619c5.585,5.469,9.694,11.993,12.274,19.101C305.145,228.935,306.442,227.62,308.025,226.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M319.705,253.682l-5.335,1.603l-2.682,0.807l-1.863,0.559l-8.059,2.422 c-2.253,0.676-4.127,2.252-5.178,4.355l-3.406,6.812c-1.741,2.866-3.764,5.523-6.076,7.883l5.879,1.077 c2.909-3.414,5.35-7.261,7.255-11.447l3.34-1.227c-1.916,4.794-4.538,9.234-7.727,13.198l5.65,1.034 c3.614-4.962,6.433-10.529,8.292-16.516l2.976-1.094c-1.801,6.561-4.702,12.67-8.498,18.116l5.529,1.012 c4.15-6.439,7.17-13.665,8.8-21.4c1.018-0.637,1.801-1.606,2.188-2.766l1.762-5.288L319.705,253.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M282.678,281.983l-0.132,0.117c-7.447,5.748-16.696,9.122-26.545,9.122 c-9.848,0-19.097-3.374-26.545-9.122l-0.132-0.117c-0.967-1.063-2.42-1.539-3.828-1.255l-25.81,5.375l5.727,5.02 c1.532,1.343,3.5,1.969,5.457,1.854c4.609,4.59,9.902,8.491,15.723,11.522l-1.677,3.095c9.247,5.028,19.838,7.887,31.084,7.887 c11.246,0,21.836-2.859,31.084-7.887l-1.677-3.095c5.821-3.031,11.114-6.933,15.723-11.522c1.958,0.115,3.926-0.512,5.458-1.854 l5.727-5.02l-25.81-5.375C285.098,280.444,283.644,280.919,282.678,281.983z M229.041,299.98c-4.64-2.414-8.888-5.463-12.711-8.97 l2.485-1.185c3.471,3.072,7.289,5.762,11.438,7.915L229.041,299.98z M295.67,291.01c-3.822,3.507-8.071,6.555-12.711,8.97 l-1.213-2.239c4.149-2.153,7.966-4.843,11.438-7.915L295.67,291.01z M256,298.901c-12.192,0-23.363-4.326-32.159-11.473 l2.554-1.218c8.305,6.397,18.625,10.131,29.603,10.131c10.978,0,21.299-3.734,29.603-10.131l2.554,1.218 C279.364,294.576,268.192,298.901,256,298.901z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M227.912,278.355c1.099,0.93,2.239,1.81,3.427,2.628h49.322c1.188-0.819,2.328-1.698,3.427-2.628 l-2.49-2.49h-51.194L227.912,278.355z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAf);
export default __webpack_public_path__ + "static/media/af.150a9fc91436e009e013a47141399103.svg";
export { ForwardRef as ReactComponent };